import _asyncToGenerator from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Analytics = /*#__PURE__*/function () {
  function Analytics() {
    _classCallCheck(this, Analytics);

    _defineProperty(this, "providers", []);

    _defineProperty(this, "isInitalized", false);
  }

  _createClass(Analytics, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(providers) {
        var collection, _iterator, _step, provider;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                collection = [];
                _iterator = _createForOfIteratorHelper(providers);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    provider = _step.value;
                    collection.push(provider.init());
                    this.providers.push(provider);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                this.isInitalized = true;
                return _context.abrupt("return", Promise.all(collection));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }

      return initialize;
    }()
  }, {
    key: "sendEvent",
    value: function () {
      var _sendEvent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data, providers) {
        var collection, _iterator2, _step2, provider, _iterator3, _step3, pr;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                collection = [];
                _iterator2 = _createForOfIteratorHelper(this.providers);

                try {
                  for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                    provider = _step2.value;

                    if (!providers) {
                      if (provider.isActive) {
                        collection.push(provider.sendEvent(data));
                      }
                    } else {
                      _iterator3 = _createForOfIteratorHelper(providers);

                      try {
                        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                          pr = _step3.value;

                          if (pr.name === provider.constructor.name) {
                            collection.push(provider.sendEvent(data));
                          }
                        }
                      } catch (err) {
                        _iterator3.e(err);
                      } finally {
                        _iterator3.f();
                      }
                    }
                  }
                } catch (err) {
                  _iterator2.e(err);
                } finally {
                  _iterator2.f();
                }

                return _context2.abrupt("return", Promise.all(collection));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function sendEvent(_x2, _x3) {
        return _sendEvent.apply(this, arguments);
      }

      return sendEvent;
    }()
  }]);

  return Analytics;
}();

export { Analytics as default };